export default __webpack_public_path__ + "static/media/logo.8a61a621.png";